module.exports = __webpack_public_path__ + "static/biswasi-692939bf238cef50e73d68e11b3158ad.jpg";